<template>
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 40 40" class="design-iconfont">
        <path fill-rule="evenodd" clip-rule="evenodd"
            d="M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z"
            fill="#FE3C44" />
        <path
            d="M25.4437 20.449C25.4437 22.1142 25.2336 23.3515 28.5089 23.7126C31.7875 24.0737 31.3666 21.6794 31.3662 20.0669C31.3649 18.2061 27.0602 15.619 20.2726 15.6173C13.4866 15.6173 9.1789 18.205 9.17888 20.067C9.17887 21.68 8.75621 24.0726 12.0332 23.7123C15.3101 23.3537 15.1 22.1155 15.0984 20.4495C15.1013 19.2862 17.7587 19.0316 20.2725 19.0298C22.7863 19.0281 25.4454 19.2844 25.4437 20.449Z"
            fill="#fff" />
    </svg>
</template>